export default __webpack_public_path__ + "static/1502-fb7051ec353d9ca314e585178df4b78c.gif";